import { signal } from '@preact/signals'
import { signOut } from './auth'

/**
 * Что делать, когда сервер отказал.
 *
 * Раньше любой отказ проглатывался: обмен ловил ошибку и возвращал «не получилось».
 * Для офлайна это верно, но отказ сервера — не офлайн. Человек думал, что данные
 * в аккаунте, а их там нет, и никто ему об этом не говорил.
 *
 * Два разных случая:
 * - `401` — ключ не подошёл (срок вышел, сессию отозвали). Выходим, данные ребёнка
 *   оставляем: после повторного входа в тот же аккаунт они нужны на месте, а приложение
 *   до входа показывает приветствие (аккаунт обязателен с 28.10.2026).
 * - `410` — аккаунта больше нет (удалили его здесь или на другом устройстве).
 *   Стираем всё: показывать данные ребёнка, которого удалили, нельзя.
 */

/** Показать плашку «сессия истекла». Гасится сама, как остальные подсказки. */
export const sessionLost = signal(false)
/** Аккаунт удалён: приложение возвращается к приветствию. */
export const accountGone = signal(false)

let wipe: (() => Promise<void>) | null = null

/** Приложение при запуске говорит, чем стирать локальные данные. */
export function onWipeRequested(fn: () => Promise<void>): void {
  wipe = fn
}

/**
 * Вызывается из всех мест, которые ходят на сервер с ключом сессии.
 * Возвращает true, если отказ разобран и повторять запрос незачем.
 */
export async function handleRejection(status: number): Promise<boolean> {
  if (status === 401) {
    signOut()
    sessionLost.value = true
    return true
  }
  if (status === 410) {
    signOut()
    await wipe?.()
    accountGone.value = true
    return true
  }
  return false
}
